/**
 * Map Provider Context
 * 현재 활성화된 맵 제공자(카카오맵 또는 OSM)를 자식 컴포넌트에 전달
 */

import { createContext, useContext, ReactNode } from "react";

type MapProvider = "kakao" | "osm";

interface MapProviderContextValue {
  mapProvider: MapProvider;
}

const MapProviderContext = createContext<MapProviderContextValue | null>(null);

export const MapProviderProvider: React.FC<{
  mapProvider: MapProvider;
  children: ReactNode;
}> = ({ mapProvider, children }) => {
  return (
    <MapProviderContext.Provider value={{ mapProvider }}>
      {children}
    </MapProviderContext.Provider>
  );
};

/**
 * 현재 활성화된 맵 제공자를 가져오는 Hook
 */
export const useCurrentMapProvider = (): MapProvider => {
  const context = useContext(MapProviderContext);
  if (!context) {
    // Context가 없으면 기본값으로 kakao 반환 (하위 호환성)
    console.warn("MapProviderContext not found, defaulting to 'kakao'");
    return "kakao";
  }
  return context.mapProvider;
};

